import React from 'react';
import DeliverableContent from './components/DeliverableContent';
import UndeliverableContent from './components/UndeliverableContent';
import LocationContextProvider from './context/LocationContext';
import type { GeoApi, DeliveryApi, LocationChangeCallback } from './types';

type OwnProps = {
  children?: (_: { content: React.ReactNode }) => React.ReactNode;
  config: {
    geoApi: GeoApi;
    fetchDelivery: DeliveryApi;
    onCloseHandler: () => void;
    onUserLocationChange?: LocationChangeCallback;
  };
  isOpen?: boolean;
};

function ModalContents() {
  return (
    <div data-package="geolocation" data-testid="geolocation-modal">
      <div className="bg-white">
        <DeliverableContent />
        <UndeliverableContent />
      </div>
    </div>
  );
}

export default function Modal({ children, config, isOpen }: OwnProps) {
  return (
    <LocationContextProvider isOpen={isOpen} {...config}>
      {children ? children({ content: <ModalContents /> }) : <ModalContents />}
    </LocationContextProvider>
  );
}
